import { StreamActions } from '@hotwired/turbo'

/**
 * @param {App} app
 */
export default function init({ app }) {
    StreamActions.toast = function () {
        const type = this.getAttribute('type')
        const message = this.getAttribute('message')

        /** @type {ModalManager} */
        const modalManager = app.get('modalManager')

        modalManager.toast(type, message)
    }
}
